module.exports = __webpack_public_path__ + "static/consulticon-70644586e80bced40ef856101facf9fa.jpeg";